export enum CalculationFormSidebarStatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
}